export default __webpack_public_path__ + "static/media/backgroundRacing.d531b485.png";